import { HttpClientModule, HttpClient} from '@angular/common/http';
import { ErrorHandler, NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicApp, IonicErrorHandler, IonicModule , DeepLinkConfig} from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation';
import { GoogleMaps } from '@ionic-native/google-maps';

//i18n
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


//Modules
import { AppConfigModule } from './app-config.module';
import { SBSuiteModule } from '../modules/sbsuite/sbsuite.module'
import { IonVirtualKeyboardModule } from '../modules/utils/ion-virtual-keyboard/ion-virtual-keyboard.module';
import { TimeInputModule } from '../modules/utils/time-input/time-input.module';
import { LogoLoaderModule } from '../modules/utils/logo-loader/logo-loader.module';
import { CalendarModule } from "ion2-calendar";
//import { AgGridModule } from 'ag-grid-angular';

/*
import {  LocationStrategy,
          HashLocationStrategy,
          APP_BASE_HREF,
          PathLocationStrategy
        } from '@angular/common';

*/

import { MyApp } from './app.component';

import { Page1 } from '../pages/page1/page1';
import { Login } from '../pages/login/login';
import { AutoClocking } from '../pages/auto-clocking/auto-clocking';
import { ProductsModal } from '../pages/product/products.modal';
import { OperationModal } from '../pages/operation/operation.modal';
import { EditClockIn } from '../pages/manually-clocking/edit-clock-in';
import { InternalsModal } from '../pages/auto-clocking/internals.modal';
import MapLocationModal from '../pages/maplocation/maplocation.modal';

/**
 * @ignore
 *
 */
export const deepLinkConfig: DeepLinkConfig = {
  links: [
      {segment: 'pagea', component: Page1},
      {segment: 'pageb', component: Page1},
      {segment: 'pagec', component: Page1, name: 'Page1'},
      {segment: 'login', component: Login, name: 'Login'},
      {segment: 'auto-clocking', component: AutoClocking, name: 'AutoClocking'}
  ]
};


/**
 * Función para la carga de los ficheros de traducción.
 *
 * @export
 * @param {HttpClient} http
 * @returns
 */
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


/**
 * Módulo principal de la aplicación.
 * @export
 * @class AppModule
 */
@NgModule({
  declarations: [
    //AutoClocking,
    //Login,
    //Page1,
    OperationModal,
    ProductsModal,
    EditClockIn,
    InternalsModal,
    MyApp,
    MapLocationModal
  ],
  imports: [
    SBSuiteModule,
    BrowserModule,
    AppConfigModule,
    HttpClientModule,
    IonVirtualKeyboardModule,
    TimeInputModule,
    LogoLoaderModule,
    CalendarModule,
    IonicStorageModule.forRoot(),
    //IonicModule.forRoot(MyApp, {}, deepLinkConfig),
    IonicModule.forRoot(MyApp),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    //AutoClocking,
    //Login,
    //Page1,
    OperationModal,
    ProductsModal,
    EditClockIn,
    InternalsModal,
    MyApp,
    MapLocationModal
  ],
  providers: [
    StatusBar,
    SplashScreen,
    //{provide: LocationStrategy, useClass: PathLocationStrategy},
    //{provide: APP_BASE_HREF, useValue : '/' },
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Geolocation,
    GoogleMaps
  ]
})
export class AppModule {

  static injector: Injector;

  constructor(injector: Injector) {
    // Make the injector to be available in the entire module
    AppModule.injector = injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts